import { AvatarState } from "@/shared/types/avatar";

export const DEFAULT_AVATAR_STATE: AvatarState = {
  slots: {
    eyes: null,
    mouth: null,
    blush: null,
    hair: null,
    shirt: null,
    shirt2: null,
    shirt3: null,
    pant: null,
    pant2: null,
    skirt: null,
    headWear: null,
    holdableRight: null,
    holdableLeft: null,
    food: null,
    chatBubble: null,
    button: null,
    button2: null,
    buttonSplash: null,
    tears: null,
    tears2: null,
    embarrassed: null,
    exclamation: null,
    explosion: null,
    heart: null,
    talkIcon: null,
    talkIcon2: null,
    talkIcon3: null,
    talkIcon4: null,
  },
};
